import {
  CERT_INVALID_MESSAGE,
  isCertificateInvalidForLogin,
} from "./certDownloadUtils";

// Estados terminais de um download job. 'completed_with_errors' = baixou
// parte mas teve falhas (sessão renovada, coleta truncada, notas sem XML,
// ou empresas com erro em jobs em massa). É FINAL — senão o polling do
// front nunca para de monitorar o job.
export const FINISHED_JOB_STATUSES = [
  "completed",
  "completed_with_errors",
  "failed",
  "cancelled",
];

export const isFinishedJobStatus = (status) =>
  FINISHED_JOB_STATUSES.includes(status);

export const isPartialJobStatus = (status) =>
  status === "completed_with_errors";

export const isLoginErrorMessage = (message) => {
  const m = (message || "").toLowerCase();
  return (
    m.includes("login") ||
    m.includes("senha") ||
    m.includes("usuário e/ou senha") ||
    m.includes("autent") ||
    m.includes("credenc")
  );
};

export const resolveCompanyDownloadError = (company) =>
  company?.last_download_company_error ||
  company?.last_download_job_error ||
  company?.last_login_error ||
  "";

export const isCompanyCertificateLoginBlocked = (company) =>
  isCertificateInvalidForLogin(company);

export const resolveLoginStatusError = (company) => {
  if (isCertificateInvalidForLogin(company)) {
    return CERT_INVALID_MESSAGE;
  }
  return resolveCompanyDownloadError(company);
};

export const isCompanyLoginFailure = (company) => {
  if (isCertificateInvalidForLogin(company)) {
    return true;
  }
  const err = resolveCompanyDownloadError(company);
  if (company?.last_login_error && isLoginErrorMessage(company.last_login_error)) {
    return true;
  }
  if (company?.last_download_company_success === false) {
    return isLoginErrorMessage(err);
  }
  return (
    company?.last_download_job_status === "failed" && isLoginErrorMessage(err)
  );
};

export const isCompanyDownloadFailure = (company) =>
  isCertificateInvalidForLogin(company) ||
  company?.last_download_company_success === false ||
  company?.last_download_job_status === "failed";
